import React, { useState, useCallback, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'
import './styles.scss'

import IntegrationAppAPI from 'api/integrationApp'
import Nixi1Spinner from 'components/Nixi1Spinner'
import ContainerPage from 'components/common/ContainerPage'
import InputText from 'components/forms/InputText'
import FormEditAPP from './FormEditAPP'
import VerificationToken from './VerificationToken'
import AppScopes from './AppScopes'

const APPEdit = (props) => {
  const { match: { params: { identifier } } } = props

  const [app, setApp] = useState({})
  const [loading, setLoading] = useState(true)

  const getAPPById = useCallback(
    async (appId) => {
      try {
        const result = await IntegrationAppAPI.findById({ identifier: appId })

        setApp(result)
      } finally {
        setLoading(false)
      }
    }, []
  )

  useEffect(
    () => {
      setLoading(true)

      getAPPById(identifier)
    }, [identifier]
  )

  return (
    <ContainerPage
      displayBeta
      title={I18n.t('nav_integrations_api_app')}
    >
      <div className='integrations-app-container'>
        <div className='integrations-app-edit'>
          <div className='integrations-app-edit__title-container'>
            <div className='integrations-app-edit__title'>
              {I18n.t('integration_app_edit_title')}
            </div>

            <div className='integrations-app-edit__info'>
              {I18n.t('integration_app_edit_info')}
            </div>
          </div>

          {
            loading
              ? (
                <div className='integrations-app-edit__loading'>
                  <Nixi1Spinner
                    height='2rem' width='2rem'
                  />
                </div>
              )
              : (
                <div className='integrations-app-edit__app_container'>
                  <FormEditAPP
                    app={app}
                    setApp={setApp}
                  />

                  <div className='integrations-app-edit__app-identifier'>
                    <InputText
                      title={I18n.t('integration_app_identifier')}
                      value={app.appId}
                      disabled
                    />
                    <InputText
                      title={I18n.t('integration_app_created_date')}
                      value={moment(app.createdAt).format('LL')}
                      disabled
                    />
                  </div>

                  <VerificationToken
                    app={app}
                    setApp={setApp}
                  />

                  <AppScopes
                    app={app}
                    setApp={setApp}
                  />
                </div>
              )
          }
        </div>
      </div>
    </ContainerPage>
  )
}

export default APPEdit
